import { gql } from '@apollo/client';

export const CHECK_NUMBER_LIMIT_QUERY = gql`
  query CheckNumberLimitQuery {
    checkNumberLimit {
      isNumbersLimitReached
    }
  }
`;
